import React from 'react'
import { v4 } from 'uuid'
import Slider from 'react-slick'
import './slick.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import Testimonial from './Testimonial'

function Testimonials({ testimonials }) {
  const slidesToShow = testimonials.length < 3 ? testimonials.length : 3
  const NextArrows = (props) => (
    <div className={props.className} onClick={props.onClick}>
      <FontAwesomeIcon icon={faArrowRight} />
    </div>
  )
  const PrevArrows = (props) => (
    <div className={props.className} onClick={props.onClick}>
      <FontAwesomeIcon icon={faArrowRight} flip="horizontal" />
    </div>
  )
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    cssEase: 'linear',
    adaptiveHeight: false,
    nextArrow: <NextArrows />,
    prevArrow: <PrevArrows />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
        },
      },
    ],
  }

  return (
    <div className="container is-fluid content patient-wrapper">
      <h2>Patient Testimonials</h2>
      <Slider {...settings}>
        {testimonials.map(({ node }) => {
          const image = node.userDetails.avatar
            ? node.userDetails.avatar.localFile.childImageSharp.gatsbyImageData
            : null
          return <Testimonial key={v4()} node={node} image={image} card />
        })}
      </Slider>
    </div>
  );
}

export default Testimonials
